module.exports = __webpack_public_path__ + "img/icon_map_32_on_010.38f46280.png";